<template>
  <direct-chat-block
    icon="language"
    :title="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.TITLE')"
    :description="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.DESC')"
  >
    <phone-input-v2
      v-model="phone"
      :label="
        $t('INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.PHONE_NUMBER.LABEL')
      "
      :placeholder="
        $t(
          'INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.PHONE_NUMBER.PLACEHOLDER'
        )
      "
    />

    <input-v2
      v-model.trim="text"
      :label="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.MESSAGE.LABEL')"
      :placeholder="
        $t('INTEGRATION_SETTINGS.DIRECT_CHAT.WA_WIDGET.MESSAGE.PLACEHOLDER')
      "
    />

    <button-v2
      class="self-start mt-2 !text-base"
      :disabled="!phoneDigits"
      @click="generate"
    >
      {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATE_SCRIPT') }}
    </button-v2>

    <template #result>
      <div>
        <div class="text-sm leading-5 font-semibold text-gray-700 mb-1.5">
          {{ $t('INTEGRATION_SETTINGS.DIRECT_CHAT.GENERATED_SCRIPT') }}
        </div>
        <copy-field-v2
          multiline
          :value="script"
          :placeholder="
            $t('INTEGRATION_SETTINGS.DIRECT_CHAT.SCRIPT_PLACEHOLDER')
          "
          :copy-label="$t('INTEGRATION_SETTINGS.DIRECT_CHAT.COPY')"
        />
      </div>
    </template>
  </direct-chat-block>
</template>

<script>
import { mapGetters } from 'vuex';
import DirectChatBlock from './DirectChatBlock.vue';
import { toPhoneDigits } from './helpers';

export default {
  name: 'WaWidget',
  components: { DirectChatBlock },
  data() {
    return {
      phone: '',
      text: '',
      script: '',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
    iPracticomFeatures() {
      return this.account.platform_features?.iPracticom;
    },
    oneCityFeatures() {
      return this.account.platform_features?.one_city;
    },
    phoneDigits() {
      return toPhoneDigits(this.phone);
    },
    brand() {
      if (this.iPracticomFeatures) {
        return {
          name: 'iPracticom',
          logo: 'ip-com-logo.svg',
          link: 'http://www.ip-com.co.il/',
        };
      }
      if (this.oneCityFeatures) {
        return {
          name: 'One City',
          link: 'https://www.onecity.co.il/',
        };
      }
      return null;
    },
  },
  methods: {
    generate() {
      if (!this.phoneDigits) {
        return;
      }
      this.script = `
     <script>
      (function(d,t) {
        var BASE_URL="${window.location.origin}";
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = BASE_URL+"/packs/js/wa_widget.js";
        var options = {
          baseUrl: BASE_URL,
          phoneNumber:"${this.phoneDigits}",
          startText: "${encodeURIComponent(this.text)}"${
            this.brand
              ? `,
          brand: ${JSON.stringify(this.brand)},`
              : ''
          }
        };
        s.onload = function() {
          window.onlineWaWidget.run(options);
        };
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      })(document,"script");
    <\u002Fscript>
        `;
    },
  },
};
</script>
